import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

declare module 'vue-router' {
  interface RouteMeta {
    title?: string;
  }
}

/** Routes with a `:param` are reached from their list and never shown in the nav (see App.vue). */
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: { title: 'Overview' },
  },
  {
    path: '/knowledge',
    name: 'knowledge',
    component: () => import('../views/KnowledgeView.vue'),
    meta: { title: 'Knowledge base' },
  },
  {
    path: '/collateral',
    name: 'collateral',
    component: () => import('../views/CollateralView.vue'),
    meta: { title: 'Collateral' },
  },
  {
    path: '/experiences',
    name: 'experiences',
    component: () => import('../views/ExperiencesView.vue'),
    meta: { title: 'Guided experiences' },
  },
  {
    path: '/experiences/:code',
    name: 'experience',
    component: () => import('../views/ExperienceEditorView.vue'),
    props: true,
    meta: { title: 'Guided experience' },
  },
  {
    path: '/walks',
    name: 'walks',
    component: () => import('../views/WalksView.vue'),
    meta: { title: 'Walks & answers' },
  },
  {
    path: '/walks/:sessionId',
    name: 'walk',
    component: () => import('../views/WalkDetailView.vue'),
    props: true,
    meta: { title: 'Walk' },
  },
  {
    path: '/roles',
    name: 'roles',
    component: () => import('../views/RolesView.vue'),
    meta: { title: 'Roles' },
  },
  {
    path: '/roles/:roleId',
    name: 'role',
    component: () => import('../views/RoleEditorView.vue'),
    props: true,
    meta: { title: 'Role' },
  },
  {
    path: '/prompts',
    name: 'prompts',
    component: () => import('../views/PromptsView.vue'),
    meta: { title: 'Prompts' },
  },
  {
    path: '/tools',
    name: 'tools',
    component: () => import('../views/ToolsView.vue'),
    meta: { title: 'Tools' },
  },
  {
    path: '/connectors',
    name: 'connectors',
    component: () => import('../views/ConnectorsView.vue'),
    meta: { title: 'Connectors' },
  },
  {
    // 🆕 20 Oct 2026 — what every voice conversation plays while the assistant is busy.
    path: '/voice',
    name: 'voice',
    component: () => import('../views/VoiceView.vue'),
    meta: { title: 'Voice' },
  },
  {
    // 🆕 PLAN-10 — the phone numbers the assistant answers, and the Zoom queues each hands callers to.
    path: '/phone-lines',
    name: 'phone-lines',
    component: () => import('../views/PhoneLinesView.vue'),
    meta: { title: 'Phone lines' },
  },
  {
    path: '/conversations',
    name: 'conversations',
    component: () => import('../views/ConversationsView.vue'),
    meta: { title: 'Conversations' },
  },
  {
    path: '/conversations/:conversationId',
    name: 'conversation',
    component: () => import('../views/ConversationDetailView.vue'),
    props: true,
    meta: { title: 'Conversation' },
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/ReportsView.vue'),
    meta: { title: 'Reports' },
  },
  {
    path: '/reports/:flagId',
    name: 'report',
    component: () => import('../views/ReportDetailView.vue'),
    props: true,
    meta: { title: 'Report' },
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('../views/CallbackView.vue'),
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title === undefined ? 'Roxxy Admin' : `${to.meta.title} · Roxxy Admin`;
});
